import { render, staticRenderFns } from "./UserManageCompany.vue?vue&type=template&id=4afdf64f&"
import script from "./UserManageCompany.vue?vue&type=script&lang=ts&"
export * from "./UserManageCompany.vue?vue&type=script&lang=ts&"
import style0 from "./UserManageCompany.vue?vue&type=style&index=0&id=4afdf64f&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports